import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { Select as BaseSelect } from 'component-library-and-tools';

import { colors } from 'lib/prisma-styles';

const SELECT_MENU_CONTAINER_CLASS_NAME = 'workflows-select-menu-container';
const SELECT_OPTION_WRAPPER_CLASS_NAME = 'workflows-select-option-wrapper';
const SELECTED_OPTION_CLASS_NAME = 'workflows-selected-option';

const StyledBaseSelect = styled(BaseSelect)`
  && {
    background-color: ${colors.interactive.defaultBackground};
    border-color: ${colors.interactive.defaultBorder};

    .${SELECT_MENU_CONTAINER_CLASS_NAME} {
      background-color: ${colors.interactive.defaultBackground};
    }

    .${SELECT_OPTION_WRAPPER_CLASS_NAME} {
      background-color: ${colors.interactive.defaultBackground};
    }

    .${SELECTED_OPTION_CLASS_NAME} {
      background-color: ${colors.interactive.selectedActive};
    }
  }
`;

const Select = ({
  menuContainerClassName,
  optionWrapperClassName,
  selectedOptionClassName,
  ...restOfProps
}: ComponentProps<typeof BaseSelect>) => (
  <StyledBaseSelect
    menuContainerClassName={SELECT_MENU_CONTAINER_CLASS_NAME}
    optionWrapperClassName={SELECT_OPTION_WRAPPER_CLASS_NAME}
    selectedOptionClassName={classnames(SELECTED_OPTION_CLASS_NAME, selectedOptionClassName)}
    {...restOfProps}
  />
);

export default Select;
